<template>
    <div class="invitedLogin absolute bg-white text-black px-4 py-4" :class="{ hidden: !isVisible }">
        <div class="close closeIcon absolute" @click.prevent="isVisible = false">
            <span class="material-icons">
                close
            </span>
        </div>
        <span class="title font-semibold text-sm">
            {{ $t('Modals.sign_in_and_get_benefits') }}
        </span>
        <br><br>
        <span class="description text-xs">
            <span class="material-icons text-green-xcaret">
                check_circle
            </span>
            {{ $t('Modals.streamline_the_purchasing_process') }}
            <br>
            <span class="material-icons text-green-xcaret">
                check_circle
            </span>
            {{ $t('Modals.store_your_purchased_albums_in_your_account') }}
            <br>
            <span class="material-icons text-green-xcaret">
                check_circle
            </span>
            {{ $t('Modals.store_albums_with_redeemed_codes_in_your_account') }}
        </span>
    </div>
</template>

<script>
export default {
    data: () => ({
        isVisible: true
    }),
    computed: {},
    watch: {},
    methods: {
        hidePopUpTimeout() {
            setTimeout(() => {
                this.isVisible = false;
            }, 20000); // 20000 milisegundos = 20 segundos
        },
    },
    created() {},
    mounted() {
        this.hidePopUpTimeout();
    },
};
</script>

<style>
.invitedLogin {
    transition: opacity 1s ease-in-out;
}

.invitedLogin.hidden {
    opacity: 0;
}
</style>